export const formatBigNumbers = (number: number) => {
	const formatter = Intl.NumberFormat('en', { notation: 'compact' });
	return formatter.format(number);
};
export const formatTime = (seconds: number) => {
	const formatter = Intl.DateTimeFormat('en-US', { minute: 'numeric', second: 'numeric' });
	const date = new Date(0);
	return formatter.format(date.setSeconds(seconds));
};
